export default __webpack_public_path__ + "static/media/delete.8c127526.svg";